export default {
  登录: "登錄",
  "请输入工号！": "請輸入工號！",
  请输入工号: "請輸入工號",
  "请输入密码！": "請輸入密碼！",
  请输入密码: "請輸入密碼",
  "7天免登录": "7天免登錄",
  "忘记密码？": "忘記密碼？",
  登录按钮: "登錄",
  首次登录提示: "首次登錄密碼為：123456， 登錄後請盡快修改密碼！",
};
